import {
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

function GewichtDeleteDialog({ open, onClose, loading, onDelete }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>
                Eintrag löschen?
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937', pt: 2 }}>
                <Typography sx={{ color: '#93c5fd' }}>
                    Möchtest du diesen Gewichtseintrag wirklich löschen? Dies kann nicht rückgängig gemacht werden.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button onClick={onClose} sx={{ color: '#93c5fd' }}>
                    Abbrechen
                </Button>
                <Button
                    onClick={onDelete}
                    variant="contained"
                    disabled={loading}
                    sx={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' }}
                >
                    Löschen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GewichtDeleteDialog;
